var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 170.994H513V341.994H0V170.994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V170.994H0V-0.00585938Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.7 135.594L350.2 126.994L342.8 107.994L324.1 114.194L332.7 135.594ZM287.1 79.5942L292.6 60.7942L273.5 53.5942L265.5 71.5942L287.1 79.5942ZM316.5 102.794L328.7 87.4942L313.8 73.5942L299.6 87.1942L316.5 102.794ZM335.9 171.694L355.4 170.894V149.594L332.5 149.794L335.9 171.694ZM323.3 209.794L342.1 215.294L349.4 196.294L331.4 188.294L323.3 209.794ZM294.3 242.194L309.2 254.894L323.6 240.494L310.5 225.794L294.3 242.194ZM247.3 94.4942L257.1 114.394L279 117.694L263.1 133.194L266.7 155.094L247.1 144.694L227.4 154.894L231.2 132.994L215.4 117.494L237.4 114.394L247.3 94.4942Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8 61.2944L248.1 79.5944C291.2 82.7944 325.1 118.794 325.1 162.694C325.1 208.694 287.8 245.594 241.7 246.094C212.5 246.394 190.4 231.294 174.7 212.394L160.8 224.694C175.8 243.694 201.6 264.594 241.7 264.594C298 264.594 343.6 218.994 343.6 162.694C343.7 109.494 302.9 65.7944 250.8 61.2944Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.9 223.394L280.1 237.394C280.1 237.394 332 276.294 333.7 277.794C335.4 279.294 338.9 279.794 342.8 275.094C346.5 270.594 345.6 266.994 343.7 265.394C341.7 263.894 291.9 223.394 291.9 223.394Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.1 157.194C198.4 167.494 198.6 180.294 208.9 188.094C208.9 188.094 344.1 289.594 345.8 291.094C347.5 292.594 351 293.094 354.9 288.394C358.6 283.894 357.7 280.294 355.8 278.694C353.9 277.194 206.1 157.194 206.1 157.194ZM253.8 256.294L261.1 274.494L280.6 268.494L275.8 249.394L253.8 256.294ZM213.4 252.594L211.4 272.094L231.5 275.694L236 256.594L213.4 252.594ZM177.7 231.394L167.4 247.994L183.8 260.094L196.3 244.894L177.7 231.394Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAo);
export default __webpack_public_path__ + "static/media/AO.09d5765fb1a4c361c8ff1db2796ec135.svg";
export { ForwardRef as ReactComponent };